/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyMuralIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-mural" */ './utils').then((m) => m.MuralIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/mural/icon' },
);

const LazyMuralSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-mural-search-result" */ './utils').then(
			(m) => m.MuralSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/mural/search-result-icon' },
);

const LazyMuralIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-mural-borderless" */ './utils').then(
			(m) => m.MuralIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/mural/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const MuralIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyMuralIconComponent />
	</Suspense>
);

export const MuralSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyMuralSearchResultIconComponent />
	</Suspense>
);

export const MuralIconBorderless = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyMuralIconBorderlessComponent />
	</Suspense>
);
